import ApiService from "@/core/services/api.service";

export default {
  select (query = {}) {
    return ApiService.query('measure_units', query)
  }
}
